import { render, staticRenderFns } from "./RenamePresentationModal.vue?vue&type=template&id=61d5072a&"
import script from "./RenamePresentationModal.vue?vue&type=script&lang=js&"
export * from "./RenamePresentationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports